import { FlagIcon } from "assets/icons";

function ReviewCard({ data }) {
  return (
    <div className="w-full flex items-start gap-8 py-6 border-t-[0.5px] border-[#112211]/25">
      <div className="flex-1 flex gap-2.5 sm:gap-4">
        <div
          className="bgImage !h-6 sm:!h-[45px] min-w-6 sm:!min-w-[45px] !w-[45px] rounded-full"
          style={{ backgroundImage: `url(${data?.dp})` }}
        />
        <div className="flex flex-col">
          <div className="flex items-center gap-2 mb-2">
            <div className="text-[12px] sm:text-sm font-semibold text-[#112211]">
              {data.rating}
            </div>
            <div className="h-[16px] w-[1px] bg-[#112211]" />
            <div className="text-[12px] sm:text-sm text-[#112211]">
              {data.name}
            </div>
          </div>
          <div className="text-[12px] leading-4 sm:text-sm text-[#112211]">
            {data.comment}
          </div>
        </div>
      </div>
      <div className="text-[#112211]  hidden lg:flex">
        <FlagIcon />
      </div>
    </div>
  );
}
export default ReviewCard;
